import React from 'react'
import { Logo, Heading } from 'base-ui'
import { PageWrapper } from '../components/PageWrapper'


const Brand = () => {
  return (
    <PageWrapper title="Brand">
      <Heading size="h3" className='mb-4'> Variants </Heading>
      <div className='flex space-x-8 mb-4'>
        <div className="p-4 border rounded">
          <Logo variant='logotype'/>
        </div>
        <div className="p-4 border rounded">
          <Logo variant='isotype'/>
        </div>
      </div>

      <Heading size="h3" className='mb-4'> Colors </Heading>
      <div className='flex space-x-8 mb-4'>
      <div className="p-4 border rounded">
        <Logo variant='logotype'/>
      </div>
        <div className="bg-blue p-4 rounded">
          <Logo variant='logotype' color='primary-on-dark'/>
        </div>
      </div>

      <Heading size="h3" className='mb-4'> Sizes </Heading>


      <div className="bg-white space-x-8 flex">
        <div className='space-y-8 border rounded p-4'>
          <Logo size="sm"/> 
          <Logo size="md"/>
          <Logo size="lg"/>
        </div>
        <div className='space-y-8 bg-blue border rounded p-4'>
          <Logo size="sm" color='primary-on-dark'/>
          <Logo size="md" color='primary-on-dark'/>
          <Logo size="lg" color='primary-on-dark'/>
        </div>
        <div className='space-y-8 border rounded p-4'>
          <Logo size="sm" color='primary-on-light' variant="isotype"/>
          <Logo size="md" color='primary-on-light' variant="isotype"/>
          <Logo size="lg" color='primary-on-light' variant="isotype"/>
        </div>
        <div className='space-y-8 bg-blue border rounded p-4'>
          <Logo size="sm" color='primary-on-dark' variant='isotype'/>
          <Logo size="md" color='primary-on-dark'variant='isotype'/>
          <Logo size="lg" color='primary-on-dark'variant='isotype'/>
        </div>
      </div>

    </PageWrapper>
  )
}

export default Brand
